<template>
    <div class="search-field search-field--destination search-field--popular-destinations">
        <input-field :name="translations.destination" :placeholder="translations.whereto" :readonly="true" :value="selectedDestinationAirportName"
            icon-type="destination" @focus="showDestinationSearch" :error="validation.destinationId" :disable-blur="true"
            :disable="disabled"></input-field>
        <modal class="modal--search-widget" :title="translations.destination" v-if="showSelector == 'destination-selector'"
            @close="onCloseDestinationAirport" :close-on-click="true" :is-open="openModal == 'destination-selector'">
            <img src="./../../../../img/icons/icon-plane-arrival.svg" alt="" slot="icon">
            <input-field :name="translations.search_txt" :placeholder="translations.whereto" :value="destinationSearchVal" icon-type="destination"
                @input="(val) => destinationSearchVal = val" @stopTyping="(val) => getDestinations(val)" ref="searchField"
                :class="{ 'item-loading': loadingDestinations }"></input-field>
            <ul class="modal-view-list" :class="{ 'loading': loadingDestinations }">
                <li class="modal-view-list__item"
                    :class="{ 'modal-view-list__item--special': (airport.type === 'special') }"
                    v-for="(airport, key) in desitinationList" :key="key" @click="selectDestinationAirport(airport)">
                    <img :src="airport.thumbnail || defaultImage" :alt="airport.name" />
                    <div class="modal-view-list__item__content">
                        <p v-text="airport.name"></p>
                        <span v-text="getType(airport.type)"></span>
                    </div>
                </li>
            </ul>

            <div class="search-popular-destinations" v-if="popularDestinationList.length">
                <div class="search-popular-destinations__item" v-for="destination in popularDestinationList" :key="destination.id"
                    @click="selectPopulareDestination(destination)">
                    <img :src="destination.img" :alt="destination.title" />
                    <p v-text="destination.title"></p>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import InputField from '../../input-field.vue';
import API from '../../../skovapi.js';
import Modal from '../../modal.vue';
import { getPuplareDestinations } from '../../../services/pupular-destinations-list.js';

export default {
    props: {
        value: { type: Object, default: null },
        validation: { type: Object, default() { return {} } },
        showSelector: { type: String, default: '' },
        openModal: { type: String, default: '' },
        emptyOnSelect: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        showCustomDestinations: { type: Boolean, default: false },
        departureAirport: { type: String, default: '' }
    },
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.FRONTPAGE_SEARCH_WIDGET,
            destinationSearchVal: '',
            loadingDestinations: false,
            destinations: [],
            popularDestinations: []
        }
    },
    watch: {
        showSelector() {
            if (this.showSelector === 'destination-selector') {
                this.$nextTick(() => {
                    this.$refs.searchField.setFocus();
                });
                this.loadPupularDestinations();
            } else if (this.emptyOnSelect) {
                this.destinationSearchVal = '';
                this.destinations = [];
            }
        }
    },
    methods: {
        loadPupularDestinations() {
            return getPuplareDestinations().then((destinationList) => {
                this.popularDestinations = destinationList;
            });
        },
        selectPopulareDestination({ region_id, img, title }) {
            this.selectDestinationAirport({
                id: region_id,
                thumbnail: img,
                name: title,
                type: (region_id == 'showalldestinations') ? 'special' : 'region'
            });
        },
        showDestinationSearch() {
            if (this.disabled)
                return;

            this.$emit('show');
        },
        onCloseDestinationAirport() {
            if (this.destinations && this.destinations.length) {
                this.selectDestinationAirport(this.destinations[0]);
            } else {
                this.$emit('hide');
            }
        },
        getDestinations(value) {
            if (this.loadingDestinations)
                return;

            if (value && value.length > 0) {
                this.loadingDestinations = true;
                API.getDestinations(value).then((res) => {
                    this.loadingDestinations = false;
                    this.destinations = res.data;
                }).catch((error) => {
                    this.loadingDestinations = false;
                    console.error(error);
                });
            } else {
                this.destinations = [];
            }
        },
        selectDestinationAirport(airport) {
            this.$emit('input', airport);
        },
        getType(type) {
            switch (type) {
                case "hotel":
                    return this.translations.type_hotel;
                case "location":
                    return this.translations.type_location;
                case "region":
                    return this.translations.type_region;
                default:
                    return '';
            }
        }
    },
    computed: {
        popularDestinationList() {
            if (this.destinationSearchVal) {
                return [];
            }

            return [
                {
                    title: 'Alle',
                    img: require("./../../../../img/popular-destinations/popular-destination-all.svg"),
                    region_id: 'showalldestinations'
                }
            ]
                .concat(this.popularDestinations);
        },
        desitinationList() {
            let list = [];
            if (this.showCustomDestinations) {
                switch (this.departureAirport) {
                    //Billund suggestions
                    case 'BLL':
                        list = list.concat([
                            {
                                id: "region-100017",
                                name: "Caribien",
                                thumbnail: null,
                                type: "region",
                            },
                            {
                                id: "region-100000",
                                name: "Baleariske Øer",
                                thumbnail: null,
                                type: "region",
                            },
                            {
                                id: "region-710",
                                name: "Den Dominikanske Republik",
                                thumbnail: "/application/files/8215/3570/4134/td-default.svg",
                                type: "region",
                            },
                            {
                                id: "region-724",
                                name: "Tyrkiet",
                                thumbnail: "/application/files/4915/3682/8619/td-turkey.svg",
                                type: "region"
                            },
                            {
                                id: "region-100002",
                                name: "Grækenland - De græske øer",
                                thumbnail: "/application/files/5315/3682/8796/td-beach.svg",
                                type: "region"
                            }
                        ]);
                        break;

                    //Lübeck suggestions
                    case 'LBC':
                        list = list.concat([
                            {
                                id: "region-100000",
                                name: "Baleariske Øer",
                                thumbnail: null,
                                type: "region",
                            },
                            {
                                id: "region-724",
                                name: "Tyrkiet",
                                thumbnail: "/application/files/4915/3682/8619/td-turkey.svg",
                                type: "region"
                            },
                            {
                                id: "region-100002",
                                name: "Grækenland - De græske øer",
                                thumbnail: "/application/files/5315/3682/8796/td-beach.svg",
                                type: "region"
                            }
                        ]);
                        break;

                    //Hannover and Bremen suggestions
                    case 'HAJ':
                    case 'BRE':
                        list = list.concat([
                            {
                                id: "region-100017",
                                name: "Caribien",
                                thumbnail: null,
                                type: "region",
                            },
                            {
                                id: "region-100000",
                                name: "Baleariske Øer",
                                thumbnail: null,
                                type: "region",
                            },
                            {
                                id: "region-851",
                                name: "De Kanariske Øer",
                                thumbnail: null,
                                type: "region"
                            },
                            {
                                id: "region-710",
                                name: "Den Dominikanske Republik",
                                thumbnail: "/application/files/8215/3570/4134/td-default.svg",
                                type: "region",
                            },
                            {
                                id: "region-651",
                                name: "Egypten",
                                thumbnail: "/application/files/4215/3570/6011/td-afrika.svg",
                                type: "region"
                            },
                            {
                                id: "region-724",
                                name: "Tyrkiet",
                                thumbnail: "/application/files/4915/3682/8619/td-turkey.svg",
                                type: "region"
                            },
                            {
                                id: "region-743",
                                name: "Bulgarien",
                                thumbnail: "/application/files/5315/3682/8796/td-beach.svg",
                                type: "region"
                            },
                            {
                                id: "region-100002",
                                name: "Grækenland - De græske øer",
                                thumbnail: "/application/files/5315/3682/8796/td-beach.svg",
                                type: "region"
                            }
                        ]);
                        break;
                    //Rostock
                    case 'RLG':
                        list = list.concat([
                            {
                                id: "region-724",
                                name: "Tyrkiet",
                                thumbnail: "/application/files/4915/3682/8619/td-turkey.svg",
                                type: "region"
                            },
                            {
                                id: "region-100002",
                                name: "Grækenland - De græske øer",
                                thumbnail: "/application/files/5315/3682/8796/td-beach.svg",
                                type: "region"
                            }
                        ])
                        break;
                    //Berlin
                    case 'TXL,BER,SXF':
                        list = list.concat([
                            {
                                id: "region-100000",
                                name: "Baleariske Øer",
                                thumbnail: null,
                                type: "region",
                            },
                            {
                                id: "region-743",
                                name: "Bulgarien",
                                thumbnail: "/application/files/5315/3682/8796/td-beach.svg",
                                type: "region"
                            },
                            {
                                id: "region-100017",
                                name: "Caribien",
                                thumbnail: null,
                                type: "region",
                            },
                            {
                                id: "region-851",
                                name: "De Kanariske Øer",
                                thumbnail: null,
                                type: "region"
                            },
                            {
                                id: "region-710",
                                name: "Den Dominikanske Republik",
                                thumbnail: "/application/files/8215/3570/4134/td-default.svg",
                                type: "region",
                            },
                            {
                                id: "region-651",
                                name: "Egypten",
                                thumbnail: "/application/files/4215/3570/6011/td-afrika.svg",
                                type: "region"
                            },
                            {
                                id: "region-100002",
                                name: "Grækenland - De græske øer",
                                thumbnail: "/application/files/5315/3682/8796/td-beach.svg",
                                type: "region"
                            },
                            {
                                id: "region-119",
                                name: "Spanien",
                                thumbnail: null,
                                type: "region"
                            },
                            {
                                id: "region-724",
                                name: "Tyrkiet",
                                thumbnail: "/application/files/4915/3682/8619/td-turkey.svg",
                                type: "region"
                            },
                        ])
                        break;
                }
            }

            let regex = new RegExp('^[' + this.destinationSearchVal + ']+', 'g');
            return list.filter((item) => {
                return item.name.match(regex) || (!this.destinationSearchVal);
            }).concat(this.destinations);
        },
        selectedDestinationAirportName() {
            return (this.value) ? this.value.name : '';
        },
        defaultImage() {
            return APP_CONFIG.THEME_PATH + '/assets/img/traveldestinations/td-default.svg';
        },
    },
    components: {
        InputField,
        Modal
    }
}
</script>
